import React, { Component } from 'react';
import Swal from 'sweetalert2'
import { RULE_FUNCTIONS, Validator } from '../../../utilities/form-validation';
import  NewsTranslated  from '../../../models/newsTranslated';
import Switch from "react-switch";

import configs from './../../../configs/config';
import { Editor } from '@tinymce/tinymce-react';
import classNames from 'classnames';
import loSanitize from 'lodash';


export default class NewsForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...(props.news ||  new NewsTranslated()),  
            errors: [],
            checked :null,
        };
        this.state.formTitle = this.state.title || 'Crear un nueva Noticia';
        this.state.editMode = this.state.id !== null;   //HAY QUE  USARLO::: 

      
        this.submitCallback = this.props.onSubmit;
        this.translateCallback = this.props.onSubmitTranslate;

        let validationRules =
            [
                {
                    fields: ['title'],
                    rule: v => RULE_FUNCTIONS.required(v)  && RULE_FUNCTIONS.maxLen(v, 70)
                },
                {
                    fields: ['slug'],
                    rule: v => RULE_FUNCTIONS.required(v) 
                },
                {
                    fields: ['kerwords'],
                    rule: v => RULE_FUNCTIONS.required(v) && RULE_FUNCTIONS.maxLen(v, 255)
                },
                {
                    fields: ['description'],
                    rule: v => RULE_FUNCTIONS.required(v)  
                },
                {
                    fields: ['body'],
                    rule: v => RULE_FUNCTIONS.required(v) 
                },
                {
                    fields:['metas'],
                    rule: v => RULE_FUNCTIONS.maxLen(v, 3000)
                },
               
            ]
        this.validator = new Validator(validationRules);
        }

    componentDidMount(){
        this.setState({
            checked : this.state.status==1?true:false,
            imagepreview : `${configs.URL_IMAGESNEW}${this.state.imageUrl}`   
        });
    }

    validateInput = (name, value) => {
        let validationResult = this.validator.validateField(name, value);
        if (validationResult) {
            let errors = this.state.errors.filter(x => x !== name);
            this.setState({ errors });
        }
        else {
            let errors = this.state.errors;
            if (errors.indexOf(name) === -1) {
                this.setState({ errors: [...errors, name] });
            }
        }
        return validationResult;
    }

    handleChangeInput = (event) => {
        let { name, value } = event.target;
        this.setState({ [name]: value });
        this.validateInput(name, value);
    }

    validateInput = (name, value) => {
        let validationResult = this.validator.validateField(name, value);
        if (validationResult) {
            let errors = this.state.errors.filter(x => x !== name);
            this.setState({ errors });
        }
        else {
            let errors = this.state.errors;
            if (errors.indexOf(name) === -1) {
                this.setState({ errors: [...errors, name] });
            }
        }
        return validationResult;
    }

    hasError = (name) => {
        return this.state.errors.indexOf(name) !== -1;
    }

    handleSubmit = (event) => {
        event.preventDefault();

        let errors = this.validator.validateState(this.state);
        if (errors.length > 0) {
            this.setState({ errors });
            Swal.fire('Error!', `cuentas con ${errors.length} error(es) en el formulario, por favor revisa los campos en rojo`, 'error');
            return false;
        }

        const formData = new FormData();
        
        formData.append('title', this.state.title);
        formData.append('slug', this.state.slug);
        formData.append('keywords', this.state.keywords);
        formData.append('description', this.state.description);
        if (this.state.imagepreview && this.state.imagepreview != this.state.imageUrl) formData.append('image', this.state.image);

        formData.append('body', loSanitize.escape(this.state.body));
        
        formData.append('status', this.state.status);
        formData.append('metas', this.state.metas);

        if (typeof this.translateCallback === "function"){
            formData.append('newsId', this.state.newsId);  //la pagina padre de la traduccion. 
            formData.append('language', this.state.language);
            this.translateCallback(formData,this.state.id,this.state.language);
        }
        else
        if (typeof this.submitCallback === "function") {
            if (this.state.id)
                this.submitCallback(formData,this.state.id);  //si el Id entonces es edicion. 
            else
                this.submitCallback(formData);  //si el Id entonces es edicion. 
        }
    }


    onChangeFile = e => {
        this.setState({
            image: e.target.files[0],
            imagepreview: URL.createObjectURL(e.target.files[0])
        });
    };

    activateCheck = checked => {
        this.setState({ checked ,
            status : checked ? "1" : "0",
        });
    };

    render() {
        return (
            <>

                <form onSubmit={this.handleSubmit} autoComplete="off">
                    <div className="">
                        <div className="modal-content">

                            <div className="panel panel-default">
                            </div>
                            <div className="modal-body">
                            <div className="row content-modal-mobile my-0 my-lg-4">
                                <div className="col-12">
                                    <div className="form-row my-3">
                                        <div className="col-12 d-flex align-items-center bt-3">
                                            <label className="form-check-label mr-3" htmlFor="priorizar" > Noticia Publicada? </label> 
                                            <Switch onChange={this.activateCheck} checked={this.state.checked?this.state.checked:false}/> 
                                        </div>
                                    </div>

                                            <div className="form-row">
                                                <div className="col-12 col-lg-6 my-3"> 
                                                    <label> Titulo de la Noticia{" "}<span className="text-red"> * </span>
                                                    <span className="text-info"> ({ this.state.title?this.state.title.length:0} / 70) caracteres</span> 

                                                     </label> 
                                                    <input type="text" autoFocus={true} name="title" value={this.state.title} className="form-control" onChange={this.handleChangeInput}required/> 
                                                </div>
                                                <div className="col-12 col-lg-6 my-3"> 
                                                    <label> URL de la Noticia{" "}<span className="text-red"> * </span> </label> 
                                                    <input type="text" name= "slug" value={this.state.slug}onChange={this .handleChangeInput}className="form-control" required/> 
                                                </div>
                                                <div className="col-12 col-lg-6 my-3"> 
                                                    <label> Keywords {" "} 
                                                        <span className="text-red"> * </span>
                                                        <span className="text-info"> ({ this.state.keywords?this.state.keywords.length:0} / 255) caracteres</span> 
                                                    </label> 
                                                    <textarea name="keywords" value={this.state.keywords}  rows="4"
                                                    onChange={this.handleChangeInput}
                                                    className={classNames('form-control', { 'is-invalid': this.hasError('keywords') })} />
                                                    <div className="invalid-feedback">Keywords  - recomedendado 100 y máximo 255 caracteres</div>
                                                </div>
                                                <div className="col-12 col-lg-6 my-3"> 
                                                        <label> Descripcion Corta de la Noticia{" "}
                                                        <span className="text-red"> * </span> 
                                                        <span className="text-info"> ({ this.state.description?this.state.description.length:0} / 160) caracteres</span> 
                                                    </label> 
                                                    <textarea rows="4" name= "description" value={this.state.description}onChange={this .handleChangeInput} required className={classNames('form-control', { 'is-invalid': this.hasError('description') })} />
                                                    <div className="invalid-feedback">cescripcion  - máximo 160 caracteres</div> 
                                                </div>
                                                <div className="col-12 col-lg-6 my-3"> 
                                                    <label> Imagen{" "}<span className="text-red"> * </span> </label> 
                                                    <input name="image" type="file" onChange={this.onChangeFile} id="img"/>  {
                                                    this.state.imagepreview ? 
                                                    <img width={'auto'}height={180}mode='fit' src={this.state.imagepreview}/> 
                                                    :  <div></div>
                                                }
                                                </div>
                                                <div className="col-12 col-lg-6 my-3"> 
                                                    <label> Metas {" "} 
                                                        <span className="text-info">  ({ this.state.metas?this.state.metas.length:0} / 3000) caracteres</span>
                                                    </label> 
                                                    <textarea rows="8" name="metas" value={this.state.metas} onChange={this.handleChangeInput}
                                                            className={classNames('form-control', { 'is-invalid': this.hasError('metas') })}></textarea>
                                                    <div className="invalid-feedback">Metadescripción  - máximo 3000 caracteres.</div>
                                                </div>
                                                <div className="col-12 my-3">
                                                    <label> Contenido de la Noticia{" "}<span className="text-red"> * </span> </label> 
                                                <Editor
                                                    apiKey={configs.TINYMCE_API_KEY} 
                                                    value={this.state.body}
                                                    init={{
                                                    height: 500,
                                                    paste_as_text: true,
                                                    images_upload_url: `${configs.URL_API_BASE}/uploadImages/image`,
                                                    automatic_uploads: true,
                                                    block_unsupported_drop: true,
                                                    menubar: false,
                                                    content_css : "https://getbootstrap.com/docs/4.5/dist/css/bootstrap.min.css",
                                                    menu: {
                                                        edit: { title: 'Edit', items: 'undo redo | cut copy paste | selectall' },
                                                        insert: { title: 'Insert', items: 'link image' },
                                                        view: { title: 'View', items: 'visualaid' },
                                                        format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats | removeformat' }
                                                    },
                                                    plugins: "image,paste,code",
                                                    paste_data_images: true,
                                                    toolbar:
                                                        'undo redo | formatselect | table link bold italic backcolor | \
                                                        alignleft aligncenter alignright alignjustify | \
                                                        bullist numlist outdent indent | removeformat | image code',
                                                    }}
                                                    onEditorChange={(content) => {
                                                        const data = content; 
                                                        this.setState({ body: data });
                                                        this.setState(prevState=>{
                                                            return{new:{...prevState.new, body: data}};
                                                        });
                                                        
                                                    }}
                                                />
                                                </div>
                                            </div>
                                   
                                </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-success btn-lg" type="submit">Guardar</button>
                                <button className="btn float-right" type="button" onClick={() => window.location.href = '/news'}>CANCELAR</button>

                            </div>
                        </div>
                    </div>
                </form>
            </>
        )

    }

}